import React, {useState} from "react";
import { Form, Row, Col, Typography, Button, Space, Image, Checkbox, Switch } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';
import Citrus from './img/Citrus.png'; import Pomme from './img/Pomme.png';
import Poire from './img/Poire.png'; import Kiwi from './img/Kiwi.svg';
import Bananes from './img/Bananes.svg'; import Fruitstropicaux from './img/Fruitstropicaux.svg';
import Kaki from './img/Kaki.svg'; import Peche from './img/Peche.svg';
import Baies from './img/Baies.svg'; import Raisin from './img/Raisin.svg';
import Grenat from './img/Grenat.svg';
const { Title, Text } = Typography;
const CheckboxGroup = Checkbox.Group;
var defaults = [];
var initValues = {
    fruits: defaults
};
const AppStep26 = ({ next, prev, handleFormData, values }) => {
    const [switched, setSwitched] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let vf = [];
    function onChange(checkedvalues) {
        return vf.push(checkedvalues);
    }
    const submitFormData = (e) => {
        if (switched === true) {
            values.fruits = JSON.stringify(defaults);
        }
        else if (switched === false){
            values.fruits = JSON.stringify(e.fruits);
        }
        onChange(e);
        next();
    }
    const onSwitch = (e) => {
        setSwitched(!switched);
        setDisabled(!disabled);
    }
    return(
        <Form 
            name="step26"
            onFinish={submitFormData}
            initialValues={initValues}
        >
            <Title level={2}>Marquez les fruits que vous souhaitez inclure :</Title>
            <Form.Item
                    name="fruits"
                    checkedvalues={values.fruits}
                    onChange={handleFormData("fruits")}
                >
            <CheckboxGroup 
               className="boxe"
               style={{ width: '100%' }}
               onChange={onChange}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Checkbox value="Citrus" disabled={disabled}><Text><Image width={18} src={Citrus} preview={false}/> Citrus</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Pomme" disabled={disabled}><Text><Image width={18} src={Pomme} preview={false}/> Pomme</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Poire" disabled={disabled}><Text><Image width={18} src={Poire} preview={false}/> Poire</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Kiwi" disabled={disabled}><Text><Image width={18} src={Kiwi} preview={false}/> Kiwi</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Bananes" disabled={disabled}><Text><Image width={18} src={Bananes} preview={false}/> Bananes</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Fruits tropicaux" disabled={disabled}><Text><Image width={18} src={Fruitstropicaux} preview={false}/> Fruits tropicaux</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Kaki" disabled={disabled}><Text><Image width={18} src={Kaki} preview={false}/> Kaki</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="La pêche" disabled={disabled}><Text><Image width={18} src={Peche} preview={false}/> La pêche</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Baies" disabled={disabled}><Text><Image width={18} src={Baies} preview={false}/> Baies</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Raisin" disabled={disabled}><Text><Image width={18} src={Raisin} preview={false}/> Raisin</Text></Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox value="Grenat" disabled={disabled}><Text><Image width={18} src={Grenat} preview={false}/> Grenat</Text></Checkbox>
                        </Col>
                    </Row>
            </CheckboxGroup>
            </Form.Item>
            <Row justify="end">
                <Col xs={{ span: 10 }} sm={{ span: 11 }} md={{ span: 11 }} lg={{ span: 9 }} xl={{ span: 7 }}>
                    <Text style={{lineHeight:2.3}} >Aucune de ces réponses </Text>
                </Col>
                <Col xs={{ span: 2 }} sm={{ span: 1 }} md={{ span: 1 }}>
                    <Form.Item layout="inline" valuePropName="checked" name="firstSwitch">
                        <Switch checked={switched} onChange={onSwitch} />
                    </Form.Item>
                </Col>
            </Row>
            <br />
        
            <Row justify="end">
            <Col xs={{ span: 8 }} sm={{ span: 6 }} md={{ span: 4 }}>
                <Form.Item  className="steps-action">
                <Space style={{ width: '100%' }}>
                    <Button onClick={prev} icon={<CaretLeftOutlined />} />
                    <Button type="primary" htmlType="submit">
                        Continue
                    </Button>
                </Space>
                </Form.Item>
            </Col>
            </Row>
        </Form>
    )
}
export default AppStep26;